export interface Movie {
  id: string;
  title: string;
  enTitle: string;
  year: number;
  duration: number;
  director: string;
  writer: string;
  cast: string[];
  genres: string[];
  rating: number;
  views: number;
  updatedAt: string;
  cover: string;
  backdrop: string;
  tagline: string;
  summary: string;
  synopsis: string[];
  region: string;
  language: string;
  featured: boolean;
}

export const movieGenres = ["剧情", "爱情", "悬疑", "文艺", "纪录", "动作"];

export const movies: Movie[] = [
  {
    id: "tokyo-dusk",
    title: "东京暮色",
    enTitle: "Tokyo Dusk",
    year: 2016,
    duration: 118,
    director: "高桥润",
    writer: "高桥润 / 森下遥",
    cast: ["苍井空", "松本启介", "木村绫乃", "大西彻"],
    genres: ["剧情", "爱情"],
    rating: 8.9,
    views: 128400,
    updatedAt: "2024-12-08",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20art%20of%20a%20rainy%20Tokyo%20backstreet%20at%20dusk%2C%20warm%20amber%20streetlights%20reflecting%20on%20wet%20pavement%2C%20a%20lone%20woman%20in%20a%20long%20coat%20walking%20away%20from%20camera%2C%20muted%20sepia%20tones%20with%20deep%20crimson%20accents%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20lettering%2C%20vertical%20editorial%20photography&width=600&height=900&seq=cover-tokyo-dusk&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20rainy%20Tokyo%20street%20at%20dusk%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20distant%20silhouette%20of%20a%20woman%20with%20an%20umbrella%2C%20warm%20amber%20and%20deep%20crimson%20tonality%2C%20soft%20film%20grain%2C%20moody%20atmosphere%2C%20no%20text%2C%20no%20lettering&width=1600&height=900&seq=backdrop-tokyo-dusk&orientation=landscape",
    tagline: "在城市的黄昏里，每个人都有一段不愿提起的往事。",
    summary:
      "一位在东京独自生活的女性，在暮色降临的街头不断与过去重逢，也逐渐学会与自己的选择和解。",
    synopsis: [
      "影片以东京一个普通街区为背景，讲述女主角美咲在夜晚便利店与白天出版社之间往返的日常。她习惯在回家路上绕远一段路，只为看一眼曾经住过的旧公寓。",
      "一次偶然的相遇让美咲重遇多年未见的旧友，两人在居酒屋聊到深夜。那些被刻意搁置的往事被重新打开，关于离开、关于留下，也关于她始终没有说出口的那句抱歉。",
      "导演高桥润用大量长镜头与自然光捕捉城市暮色，把情绪的起伏藏在街灯、雨声与沉默里。影片没有给出明确的答案，却让人相信，和解有时只是愿意再多看这座城市一眼。",
    ],
    region: "日本",
    language: "日语",
    featured: true,
  },
  {
    id: "silent-confession",
    title: "无声的告白",
    enTitle: "Silent Confession",
    year: 2014,
    duration: 106,
    director: "佐藤千夏",
    writer: "佐藤千夏",
    cast: ["苍井空", "林原树里", "中村海", "藤井千鹤"],
    genres: ["剧情"],
    rating: 8.6,
    views: 96200,
    updatedAt: "2024-11-02",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20cinematic%20poster%20of%20a%20quiet%20room%20with%20sheer%20curtains%20and%20soft%20morning%20light%2C%20a%20woman%20seated%20by%20the%20window%20seen%20from%20behind%2C%20muted%20cream%20and%20dusty%20rose%20palette%2C%20delicate%20film%20grain%2C%20restrained%20melancholic%20mood%2C%20no%20text%2C%20no%20lettering%2C%20vertical%20composition&width=600&height=900&seq=cover-silent-confession&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20sunlit%20Japanese%20apartment%20living%20room%20with%20sheer%20curtains%20floating%20in%20the%20breeze%2C%20wooden%20floor%2C%20single%20chair%20by%20the%20window%2C%20muted%20cream%20and%20dusty%20rose%20tones%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1600&height=900&seq=backdrop-silent-confession&orientation=landscape",
    tagline: "有些话说出口需要一生，有些沉默却只需要一个下午。",
    summary:
      "一场家庭聚会之后，长期沉默的母女终于坐在同一张桌前，用一整个下午交换彼此错过的十年。",
    synopsis: [
      "女主角佐和子多年未曾回家，母亲的一通电话把她重新拉回海边小镇。屋子里的一切都停在十年前：旧挂钟、褪色相册，以及那张永远只摆两副碗筷的餐桌。",
      "影片几乎全部发生在一天之内，用细碎的日常动作推进叙事：削苹果、晾衣服、收拾碗柜。母女之间的对话总是断在半句上，真正想说的话则藏在沉默的间隙里。",
      "佐藤千夏的剧本克制而准确，把东方式家庭关系中的体谅与别扭同时呈现出来。结尾没有拥抱，只有一个被轻轻推到对方面前的茶杯，却比任何告白都更有分量。",
    ],
    region: "日本",
    language: "日语",
    featured: false,
  },
  {
    id: "summer-of-tsukimizaka",
    title: "月见坂的夏天",
    enTitle: "Summer of Tsukimizaka",
    year: 2018,
    duration: 112,
    director: "小林修一",
    writer: "小林修一 / 青木葵",
    cast: ["苍井空", "山崎亮", "小野寺萌", "岸本修"],
    genres: ["爱情", "文艺"],
    rating: 8.8,
    views: 111500,
    updatedAt: "2024-10-21",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20cinematic%20poster%20of%20a%20steep%20Japanese%20hillside%20street%20in%20summer%2C%20electric%20poles%20and%20green%20foliage%2C%20evening%20sunlight%20casting%20long%20shadows%2C%20muted%20olive%20and%20soft%20amber%20tones%2C%20analog%20film%20texture%2C%20no%20text%2C%20no%20lettering%2C%20vertical%20editorial%20photography&width=600&height=900&seq=cover-tsukimizaka&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20summer%20cinematic%20still%20of%20a%20quiet%20Japanese%20hillside%20neighborhood%20at%20golden%20hour%2C%20utility%20poles%20and%20dense%20green%20trees%2C%20narrow%20stone%20stairs%20leading%20uphill%2C%20warm%20amber%20haze%2C%20muted%20olive%20tones%2C%20analog%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1600&height=900&seq=backdrop-tsukimizaka&orientation=landscape",
    tagline: "那个夏天没有结局，只有一次次走过同一段坡道。",
    summary:
      "在月见坂经营旧书店的女人，与每年夏天都会来寄住一晚的青年，共同守住了一段没有名字的感情。",
    synopsis: [
      "月见坂是一条通往山顶的长坡，女主角在这里经营一家几乎没有客人的旧书店。每年八月，一位青年会带着同一只旅行袋出现，在书店二楼住上一晚，然后离开。",
      "两人的关系始终停在朋友与恋人之间。他们谈论书、谈论天气、谈论那些从未去成的地方，却从不谈下一次见面。夏天像一种约定，也像一种不必负责的借口。",
      "影片用大量固定机位记录坡道的四季变化，把等待拍得温柔而不苦涩。当最后一年青年没有出现，女主角只是把门前的灯换成了更亮的一盏。",
    ],
    region: "日本",
    language: "日语",
    featured: false,
  },
  {
    id: "night-train",
    title: "夜行列车",
    enTitle: "Night Train",
    year: 2013,
    duration: 124,
    director: "黑木原",
    writer: "黑木原 / 早川真",
    cast: ["苍井空", "津田健吾", "白石奈绪", "森川大辅"],
    genres: ["悬疑", "剧情"],
    rating: 8.4,
    views: 87900,
    updatedAt: "2024-09-14",
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20cinematic%20poster%20of%20an%20empty%20night%20train%20carriage%2C%20cool%20fluorescent%20light%20mixing%20with%20deep%20amber%20glow%20from%20the%20windows%2C%20a%20woman%20seated%20alone%20looking%20toward%20the%20dark%20corridor%2C%20muted%20charcoal%20and%20crimson%20tones%2C%20film%20grain%2C%20no%20text%2C%20no%20lettering%2C%20vertical%20composition&width=600&height=900&seq=cover-night-train&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20inside%20an%20empty%20night%20train%2C%20long%20corridor%20of%20seats%2C%20cold%20fluorescent%20lighting%20with%20deep%20amber%20window%20glow%2C%20dark%20countryside%20passing%20outside%2C%20charcoal%20and%20crimson%20palette%2C%20soft%20film%20grain%2C%20suspenseful%20atmosphere%2C%20no%20text%2C%20no%20lettering&width=1600&height=900&seq=backdrop-night-train&orientation=landscape",
    tagline: "列车不停站，而每个人都带着不能被看见的秘密。",
    summary:
      "末班夜行列车上，六位互不相识的乘客因为一次临时停车被困在同一节车厢，彼此的秘密开始浮出水面。",
    synopsis: [
      "深夜十一点四十分，开往北方的末班列车因线路故障临时停靠。六位乘客被留在同一节车厢里，手机没有信号，广播只剩杂音。",
      "随着等待时间变长，乘客之间原本客气的交谈逐渐变成试探。有人认出了其中一位乘客，有人则始终不肯说出自己的目的地。一件遗落的行李，让所有人的叙述开始互相矛盾。",
      "黑木原把悬疑建立在人物关系之上，而不是单纯的谜题。影片最后并未完全揭示真相，却让每个人藏起来的那部分自己，都在天亮前露出了一点轮廓。",
    ],
    region: "日本",
    language: "日语",
    featured: false,
  },
  {
    id: "white-echo",
    title: "白色回声",
    enTitle: "White Echo",
    year: 2019,
    duration: 96,
    director: "相田真纪",
    writer: "相田真纪",
    cast: ["苍井空", "松冈由纪", "田野惠", "石井诚"],
    genres: ["纪录", "文艺"],
    rating: 9.1,
    views: 134700,
    updatedAt: "2024-12-12",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20documentary%20cinematic%20poster%20of%20a%20snowy%20northern%20Japanese%20village%20at%20blue%20hour%2C%20soft%20mist%2C%20a%20single%20lit%20window%20glowing%20warm%20amber%2C%20pale%20ivory%20and%20cold%20grey%20palette%20with%20subtle%20warm%20accent%2C%20delicate%20grain%2C%20no%20text%2C%20no%20lettering%2C%20vertical%20composition&width=600&height=900&seq=cover-white-echo&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20documentary%20film%20still%20of%20a%20snow%20covered%20northern%20Japanese%20village%20at%20dusk%2C%20quiet%20empty%20street%2C%20warm%20light%20spilling%20from%20a%20small%20wooden%20house%2C%20falling%20snow%2C%20pale%20ivory%20and%20cool%20grey%20tones%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1600&height=900&seq=backdrop-white-echo&orientation=landscape",
    tagline: "当声音被雪吸收，留下来的只有人自己的呼吸。",
    summary:
      "一部关于北方小镇冬季日常的纪录长片，用安静的镜头记录留守者、旧车站与一场持续了四十年的雪。",
    synopsis: [
      "摄制组在北方小镇度过了三个冬天，跟随五位常住居民记录他们的日常：扫雪、烧水、等一班每天只来一次的列车。",
      "影片几乎没有旁白，声音设计成为最重要的叙事手段。铲雪声、炉火声、远处的广播，共同构成了小镇的时间刻度。苍井空以观察者的身份出现，与居民一起生活、聊天，也一起沉默。",
      "相田真纪把纪录片拍成了一种陪伴。影片没有刻意呈现苦难，而是让观众看到一种被反复练习过的生活秩序，以及秩序之中仍然存在的温柔。",
    ],
    region: "日本",
    language: "日语",
    featured: true,
  },
  {
    id: "distance-to-the-sea",
    title: "她与海的距离",
    enTitle: "Distance to the Sea",
    year: 2017,
    duration: 108,
    director: "石川凌",
    writer: "石川凌 / 长谷川澪",
    cast: ["苍井空", "冈田悠真", "三浦沙耶", "远藤修"],
    genres: ["文艺", "爱情"],
    rating: 8.7,
    views: 103800,
    updatedAt: "2024-08-30",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20poster%20of%20a%20woman%20standing%20on%20a%20quiet%20seaside%20platform%20looking%20at%20a%20calm%20grey%20ocean%2C%20soft%20overcast%20light%2C%20wind%20in%20her%20hair%2C%20muted%20slate%20blue%20grey%20and%20sand%20tones%20with%20a%20touch%20of%20crimson%2C%20film%20grain%2C%20no%20text%2C%20no%20lettering%2C%20vertical%20editorial%20photography&width=600&height=900&seq=cover-distance-sea&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20lonely%20seaside%20train%20platform%20in%20overcast%20weather%2C%20calm%20grey%20ocean%20stretching%20to%20the%20horizon%2C%20weathered%20wooden%20bench%2C%20muted%20slate%20grey%20and%20sand%20palette%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1600&height=900&seq=backdrop-distance-sea&orientation=landscape",
    tagline: "她始终没有走近海，却从未真正离开过。",
    summary:
      "海边小镇的广播员每天播报潮汐与天气，直到一位陌生旅客的到来，让她重新面对自己停摆多年的生活。",
    synopsis: [
      "女主角在小镇广播站工作，每天清晨播报潮汐时间与天气。她的生活规律得像一张潮汐表，几乎没有意外，也没有期待。",
      "一位来小镇写生的旅客打破了这个节奏。他问她为什么从不去海边，她只说工作太忙。随着相处时间变长，这个回避的问题开始有了重量。",
      "石川凌用海雾与光线变化表现时间的流动，把爱情拍成一种缓慢的靠近。结尾女主角终于走到防波堤尽头，画面停在海平面上，什么都没有发生，却什么都改变了。",
    ],
    region: "日本",
    language: "日语",
    featured: false,
  },
  {
    id: "under-the-fireworks",
    title: "花火之下",
    enTitle: "Under the Fireworks",
    year: 2012,
    duration: 130,
    director: "武田徹",
    writer: "武田徹 / 桥本和",
    cast: ["苍井空", "真田航", "柴田理惠", "大冢亮"],
    genres: ["动作", "剧情"],
    rating: 8.2,
    views: 79500,
    updatedAt: "2024-07-19",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20poster%20of%20a%20summer%20festival%20night%20sky%20filled%20with%20golden%20fireworks%2C%20silhouetted%20crowd%20and%20a%20woman%20standing%20apart%20from%20them%2C%20warm%20gold%20and%20deep%20crimson%20tones%2C%20high%20contrast%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20lettering%2C%20vertical%20composition&width=600&height=900&seq=cover-fireworks&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20Japanese%20summer%20festival%20at%20night%2C%20golden%20fireworks%20bursting%20over%20the%20rooftops%2C%20crowded%20street%20with%20lanterns%2C%20deep%20crimson%20and%20amber%20light%2C%20atmospheric%20smoke%2C%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1600&height=900&seq=backdrop-fireworks&orientation=landscape",
    tagline: "烟花只亮一瞬，而有些决定要用一整年去偿还。",
    summary:
      "一场夏祭的烟火之下，前拳手与旧日同伴再度相遇，一段没打完的比赛与一笔旧账同时被点燃。",
    synopsis: [
      "女主角曾经是地下拳场的边缘人物，退出多年后靠经营小酒馆维生。夏祭当晚，一个熟悉的身影出现在店门口，带着她最不想听到的消息。",
      "为了保住小酒馆和身边的人，她不得不重新回到那个曾经让她失去一切的地方。影片的动作场面拍得克制，力量感来自人物的犹豫与停顿，而不是单纯的挥拳。",
      "武田徹把类型片的情感核心落在羁绊上。烟花在结尾再次亮起，人群依旧喧闹，而她终于愿意承认，有些战斗并不是为了赢。",
    ],
    region: "日本",
    language: "日语",
    featured: false,
  },
  {
    id: "the-second-window",
    title: "第二扇窗",
    enTitle: "The Second Window",
    year: 2020,
    duration: 115,
    director: "高桥润",
    writer: "高桥润 / 森下遥",
    cast: ["苍井空", "成田圭", "宫原理沙", "小柳彻"],
    genres: ["剧情", "悬疑"],
    rating: 8.5,
    views: 118600,
    updatedAt: "2024-12-01",
    cover:
      "https://readdy.ai/api/search-image?query=Enigmatic%20cinematic%20poster%20of%20an%20apartment%20corridor%20with%20two%20identical%20windows%2C%20one%20lit%20warm%20amber%20and%20one%20dark%2C%20a%20woman%20standing%20between%20them%20seen%20from%20behind%2C%20muted%20brown%20and%20deep%20red%20palette%2C%20film%20grain%2C%20quiet%20unease%2C%20no%20text%2C%20no%20lettering%2C%20vertical%20composition&width=600&height=900&seq=cover-second-window&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20dim%20apartment%20corridor%20with%20two%20opposite%20windows%2C%20warm%20amber%20light%20from%20one%20side%20and%20darkness%20from%20the%20other%2C%20long%20shadows%20on%20the%20floor%2C%20muted%20brown%20and%20deep%20red%20tones%2C%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1600&height=900&seq=backdrop-second-window&orientation=landscape",
    tagline: "她搬进来的第一天，就发现房间有两扇一模一样的窗。",
    summary:
      "一位刚搬进旧公寓的女性发现，邻居口中那间「不存在的房间」每晚都会亮起灯，而灯后似乎有人正在看着她。",
    synopsis: [
      "女主角因工作调动搬进一栋老公寓，房东反复叮嘱她不要在意走廊尽头的那扇窗。第一个晚上，她就看见那扇窗亮了。",
      "随着调查深入，她发现这栋楼过去的住户记录存在明显空白，而每一位曾经的租客都提到过同一件小事：夜里会听见有人轻轻敲窗。",
      "高桥润延续了他对城市空间的兴趣，把公寓楼拍成一个有呼吸的容器。影片的笑点与不安都来自日常细节，最后的解释朴素得近乎残酷，却让人回味很久。",
    ],
    region: "日本",
    language: "日语",
    featured: true,
  },
  {
    id: "slow-shutter",
    title: "慢速快门",
    enTitle: "Slow Shutter",
    year: 2021,
    duration: 88,
    director: "相田真纪",
    writer: "相田真纪 / 苍井空",
    cast: ["苍井空", "中込大树", "宇野千寻"],
    genres: ["纪录"],
    rating: 8.9,
    views: 92400,
    updatedAt: "2024-11-25",
    cover:
      "https://readdy.ai/api/search-image?query=Thoughtful%20documentary%20poster%20of%20a%20vintage%20film%20camera%20on%20a%20wooden%20table%2C%20scattered%20black%20and%20white%20photographs%2C%20soft%20window%20light%2C%20hands%20sorting%20prints%2C%20muted%20sepia%20and%20warm%20grey%20palette%2C%20delicate%20film%20grain%2C%20no%20text%2C%20no%20lettering%2C%20vertical%20editorial%20still%20life&width=600&height=900&seq=cover-slow-shutter&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20documentary%20still%20of%20a%20small%20darkroom%20with%20hanging%20black%20and%20white%20photographs%2C%20red%20safelight%20glow%2C%20developing%20trays%20on%20a%20wooden%20bench%2C%20muted%20sepia%20and%20warm%20grey%20tones%2C%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1600&height=900&seq=backdrop-slow-shutter&orientation=landscape",
    tagline: "把快门放慢一点，才能看见生活真正的速度。",
    summary:
      "苍井空跟随三位胶片摄影师走过一年，记录他们如何在数码时代坚持用慢速快门留住时间。",
    synopsis: [
      "影片从一个很小的问题开始：为什么还要用胶片？三位摄影师给出了完全不同的答案，有人为了等待，有人为了遗忘，也有人只是习惯了那种不确定。",
      "摄制组跟随他们拍摄街头、婚礼与空荡的工厂。镜头并不回避失败，曝光错误的底片、被退回的委托、无人观看的展览，都被完整地保留下来。",
      "作为一部关于观看的纪录片，《慢速快门》自己也非常安静。它没有说服任何人去使用胶片，只是把一种正在消失的耐心，认真地记录了下来。",
    ],
    region: "日本",
    language: "日语",
    featured: false,
  },
  {
    id: "before-the-dawn",
    title: "长夜将尽",
    enTitle: "Before the Dawn",
    year: 2015,
    duration: 121,
    director: "黑木原",
    writer: "早川真 / 黑木原",
    cast: ["苍井空", "小泉亮介", "野中美咲", "高木原"],
    genres: ["悬疑", "剧情"],
    rating: 8.3,
    views: 86200,
    updatedAt: "2024-06-08",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20poster%20of%20an%20empty%20harbor%20at%204am%20with%20a%20single%20streetlamp%20and%20a%20woman%20waiting%20by%20a%20parked%20car%2C%20cold%20blue%20grey%20dawn%20approaching%20with%20a%20warm%20orange%20horizon%20line%2C%20deep%20charcoal%20and%20amber%20accents%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20lettering%2C%20vertical%20composition&width=600&height=900&seq=cover-before-dawn&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20an%20empty%20fishing%20harbor%20just%20before%20dawn%2C%20cold%20grey%20mist%20over%20the%20water%2C%20single%20streetlamp%20and%20a%20parked%20car%2C%20faint%20warm%20orange%20horizon%2C%20charcoal%20and%20amber%20palette%2C%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1600&height=900&seq=backdrop-before-dawn&orientation=landscape",
    tagline: "天亮之前的四个小时，足够让一件事彻底改变。",
    summary:
      "一位夜班出租车司机在凌晨接到一位特殊乘客，两人在港口的四小时里，共同拼凑出一桩旧案的另一种可能。",
    synopsis: [
      "凌晨两点，女主角在港口接到一位没有说清目的地的乘客。对方只要求她沿着海岸线一直开，直到天亮。",
      "谈话从天气开始，逐渐转向一桩多年前的失踪案。乘客似乎知道很多细节，却始终不肯说明自己与案件的关系。女主角也开始意识到，这趟行程并不偶然。",
      "影片几乎完全依靠对话与夜色推进，车内空间成为唯一的舞台。结尾天光乍现，两个人的选择都很安静，却各自承担了不同的重量。",
    ],
    region: "日本",
    language: "日语",
    featured: false,
  },
  {
    id: "ginza-remains",
    title: "银座旧梦",
    enTitle: "Ginza Remains",
    year: 2011,
    duration: 127,
    director: "小林修一",
    writer: "小林修一 / 青木葵",
    cast: ["苍井空", "长谷川诚", "松平今日子", "大久保武"],
    genres: ["爱情", "剧情"],
    rating: 8.0,
    views: 74800,
    updatedAt: "2024-05-16",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20cinematic%20poster%20of%20a%20vintage%20Ginza%20bar%20interior%20at%20night%2C%20amber%20lamp%20glow%20on%20dark%20wood%2C%20a%20woman%20in%20an%20elegant%20dress%20seen%20in%20soft%20focus%20behind%20glass%2C%20muted%20gold%20and%20deep%20burgundy%20palette%2C%20film%20grain%2C%20no%20text%2C%20no%20lettering%2C%20vertical%20composition&width=600&height=900&seq=cover-ginza-remains&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20nostalgic%20Ginza%20back%20alley%20at%20night%2C%20warm%20lamps%20glowing%20behind%20small%20bar%20windows%2C%20wet%20stone%20pavement%2C%20muted%20gold%20and%20deep%20burgundy%20tones%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1600&height=900&seq=backdrop-ginza-remains&orientation=landscape",
    tagline: "那条街还在，只是灯亮给的人换了。",
    summary:
      "银座一家老酒吧闭店前的最后一个月，老板娘与三位常客各自面对一段即将结束的关系。",
    synopsis: [
      "这家开在银座小巷里的酒吧已经营了三十年，因街区改造即将关闭。老板娘决定照常营业到最后一晚，不做任何告别活动。",
      "三位常客依旧每晚出现，点同样的酒，坐在同样的位置。他们谈论工作、谈论旧人，也谈论这家店关门之后该去哪里，却谁也没有真正说出挽留。",
      "小林修一把镜头对准酒杯、烟灰与半开的门，让空间本身成为主角。影片的最后一场戏里，老板娘独自擦完最后一只杯子，关灯，走出巷子，没有回头。",
    ],
    region: "日本",
    language: "日语",
    featured: false,
  },
  {
    id: "vernal-equinox",
    title: "春分",
    enTitle: "Vernal Equinox",
    year: 2022,
    duration: 103,
    director: "石川凌",
    writer: "石川凌 / 长谷川澪",
    cast: ["苍井空", "高梨优", "村上沙希", "并木卓"],
    genres: ["剧情", "文艺"],
    rating: 8.8,
    views: 105900,
    updatedAt: "2024-12-15",
    cover:
      "https://readdy.ai/api/search-image?query=Gentle%20cinematic%20poster%20of%20a%20quiet%20suburban%20Japanese%20garden%20in%20early%20spring%2C%20cherry%20buds%20not%20yet%20open%2C%20a%20woman%20sitting%20on%20a%20wooden%20porch%20with%20a%20cup%20of%20tea%2C%20soft%20pale%20peach%20and%20sage%20green%20palette%2C%20delicate%20film%20grain%2C%20calm%20contemplative%20mood%2C%20no%20text%2C%20no%20lettering%2C%20vertical%20composition&width=600&height=900&seq=cover-vernal-equinox&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20suburban%20Japanese%20garden%20in%20early%20spring%2C%20bare%20cherry%20branches%20with%20tiny%20buds%2C%20wooden%20porch%20and%20a%20cup%20of%20steaming%20tea%2C%20soft%20overcast%20light%2C%20pale%20peach%20and%20sage%20green%20tones%2C%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1600&height=900&seq=backdrop-vernal-equinox&orientation=landscape",
    tagline: "白天和黑夜一样长的那天，她决定重新开始。",
    summary:
      "春分这天，一位女性回到阔别多年的家中整理遗物，也在一天之内重新认识了母亲与自己。",
    synopsis: [
      "女主角在春分当天回到老家，处理母亲留下的房子。她只计划停留一天，把事情办完就返回东京。",
      "整理过程中，她陆续找到一些被保存得很好的旧东西：写了一半的信、没有寄出的明信片、记录她每一次演出的剪报。那些她以为母亲从不在意的时刻，其实都被认真收着。",
      "影片把叙事压缩在二十四小时里，用光线变化标记时间的流逝。傍晚时分，她坐在廊下喝完那杯已经凉掉的茶，决定把房子留下来。",
    ],
    region: "日本",
    language: "日语",
    featured: false,
  },
];